import { ShareButton } from "@/components/ShareButton";

// Bottom-of-page strip inviting visitors to share the current guide.
export const ShareBar = ({ title }) => (
  <section data-testid="share-bar" className="bg-[#F9F8F6] border-t border-dotted border-zinc-300">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14 flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
      <div>
        <p className="font-display font-900 tracking-tight text-xl md:text-2xl">
          Found this useful?
        </p>
        <p className="font-body text-sm text-black/55 mt-1">
          Send it to whoever you&apos;re travelling with.
        </p>
      </div>
      <ShareButton title={title} testid="share-bar-btn" className="shrink-0" />
    </div>
  </section>
);
